import { useEffect, useState } from "react";
import { apiFetch } from "../api/apiFetch";
import { useSession } from "@supabase/auth-helpers-react";
import BrandForm from "./BrandForm";

export default function ProductForm({ onSubmit }) {
  const session = useSession();
  const [brands, setBrands] = useState([]);
  const [form, setForm] = useState({
    name: "",
    brand_id: "",
    sku: "",
    description: "",
  });
  const [error, setError] = useState(null);
  const [showAddBrandModal, setShowAddBrandModal] = useState(false);

  useEffect(() => {
    fetchBrands();
  }, [session]);

  const fetchBrands = () => {
    apiFetch("/brands")
      .then((data) => setBrands(data))
      .catch((err) => {
        console.error("Fout bij ophalen merken:", err);
        setError("Kon merken niet ophalen");
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleCreateBrand = async (brandData) => {
    const newBrand = await apiFetch("/brands", {
      method: "POST",
      body: JSON.stringify(brandData),
    });
    fetchBrands();
    setShowAddBrandModal(false);
    setForm((prev) => ({ ...prev, brand_id: newBrand.id }));
    return newBrand;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <>
    <form onSubmit={handleSubmit} className="space-y-4">
      {error && <p className="text-red-600">{error}</p>}

      <div>
        <label className="block font-medium mb-1">Naam</label>
        <input
          name="name"
          className="border rounded p-2 w-full"
          value={form.name}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label className="block font-medium mb-1">Merk</label>
        <div className="flex gap-2">
          <select
            name="brand_id"
            className="border rounded p-2 w-full"
            value={form.brand_id}
            onChange={handleChange}
            required
          >
            <option value="">Kies een merk</option>
            {Array.isArray(brands) &&
              brands.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
          </select>
          <button
            type="button"
            onClick={() => setShowAddBrandModal(true)}
            className="px-3 bg-gray-600 text-white rounded hover:bg-gray-700"
            title="Nieuw merk aanmaken"
          >
            +
          </button>
        </div>
      </div>

      <div>
        <label className="block font-medium mb-1">Barcode (EAN)</label>
        <input
          name="sku"
          className="border rounded p-2 w-full"
          value={form.sku}
          onChange={handleChange}
          placeholder="Scan de verpakkingsbarcode, of laat leeg"
        />
        <p className="mt-1 text-xs text-gray-500">
          Nodig om dit product automatisch te herkennen bij het scannen aan de balie.
        </p>
      </div>

      <div>
        <label className="block font-medium mb-1">Omschrijving</label>
        <textarea
          name="description"
          className="border rounded p-2 w-full"
          value={form.description}
          onChange={handleChange}
          rows="3"
        />
      </div>

      <button
        type="submit"
        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
      >
        Opslaan
      </button>
    </form>

    {showAddBrandModal && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg p-6 w-full max-w-md">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold">Nieuw Merk Toevoegen</h2>
            <button
              type="button"
              onClick={() => setShowAddBrandModal(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>
          <BrandForm onSubmit={handleCreateBrand} />
        </div>
      </div>
    )}
    </>
  );
}
